import React, { useEffect } from "react";
import { useAuth } from "./items/AuthProvider";
import { useNavigate } from "react-router-dom";

const Logout = () => {
  const history = useNavigate();
  const { user, setUser } = useAuth();
  useEffect(() => {
    setUser(null);
    localStorage.removeItem("user");
    history(`/login/${user?.groupCode}`);
  }, []);

  return <div className="page-container"></div>;
};

export default Logout;
